export const DEFAULT_EMAIL = 'info@cmgroups.in';

export const COMPANY_CONTACT_EMAILS = {
  'dhanalakshmi-engineers': 'dhan.eng@cmgroups.in',
  'dev-design-studio': 'devdesignstudio@cmgroups.in',
  'cm-homes': 'cmhomes@cmgroups.in',
  'cm-mahal': 'vigneshwar@cmgroups.in',
  'cm-luxury-stays': 'info@cmgroups.in'
};

export const getEmailForCompanyId = (companyId) =>
  COMPANY_CONTACT_EMAILS[companyId] || DEFAULT_EMAIL;

export const getEmailForPath = (pathname) => {
  const match = pathname.match(/\/company\/([^/]+)/);
  return match ? getEmailForCompanyId(match[1]) : DEFAULT_EMAIL;
};
